export default [
  {
    path: '/analyze/revenue',
    name: 'report-revenue',
    component: () => import('@/views/reports/RevenueReport.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_analyze_menu',
      resource: 'all',
    },
  },
  {
    path: '/analyze/churn',
    name: 'report-churn',
    component: () => import('@/views/reports/ChurnReport.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_analyze_menu',
      resource: 'all',
    },
  },
  {
    path: '/analyze/payments-users',
    name: 'report-payments-users',
    component: () => import('@/views/reports/PaymentAndUserReport.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_analyze_menu',
      resource: 'all',
    },
  },
]
